<template>
  <div>
    <!-- 顶部按钮 -->
    <el-button type="primary" size="small" @click="openAdd" style="margin-top: 10px">
      新增提额策略
    </el-button>

    <!-- 表格 -->
    <el-table :data="mergedPolicyList" border style="margin-top: 15px; width: 100%">
      <el-table-column prop="platform" label="平台" />
      <el-table-column prop="white_type" label="白名单类型" />
      <el-table-column label="策略详情">
        <template #default="scope">
          <div
            v-for="(policy, index) in scope.row.policy_adjust"
            :key="index"
            style="margin-bottom: 10px; padding: 8px; border: 1px dashed #e0e0e0"
          >
            <div>
              <strong>策略 {{ index + 1 }}：</strong>
            </div>
            <div>调整方式: {{ policy.effect }}</div>
            <div>优先级: {{ policy.priority }}</div>
            <div>调整值: {{ policy.value }}</div>
            <div>调整类型: {{ policy.value_type }}</div>
            <div>上限: {{ policy.celiling_limit }}</div>
            <div>下限: {{ policy.floor_limit }}</div>
            <div>期限(天): {{ policy.term_days }}</div>
            <div>利息: {{ policy.interest }}</div>
            <div>服务费: {{ policy.service_charge }}</div>
            <div>可分期: {{ policy.can_aging === 1 ? "是" : "否" }}</div>
            <div>可展期: {{ policy.can_extend === 1 ? "是" : "否" }}</div>
            <div>场景描述: {{ policy.decision_scene }}</div>
          </div>
        </template>
      </el-table-column>

      <el-table-column label="操作" width="200">
        <template #default="scope">
          <el-button
            size="mini"
            type="primary"
            @click="openEditByPlatform(scope.row.platform, scope.row.white_type)"
            >编辑</el-button
          >
          <el-button size="mini" type="danger" @click="remove(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 弹窗 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="900px">
      <el-form :model="form" label-width="120px">
        <!-- 平台 -->
        <el-form-item label="App名称">
          <el-select v-model="form.platform" placeholder="请选择">
            <el-option
              v-for="item in productList"
              :key="item.id"
              :label="item.productName"
              :value="item.productName"
            />
          </el-select>
        </el-form-item>

        <!-- 白名单类型 -->
        <el-form-item label="白名单类型">
          <el-input v-model="form.white_type" style="width: 220px" />
        </el-form-item>

        <el-divider>策略列表</el-divider>

        <!-- 动态策略 -->
        <div
          v-for="(item, index) in form.policy_adjust"
          :key="index"
          style="
            border: 1px solid #ebeef5;
            padding: 15px;
            margin-bottom: 15px;
            border-radius: 6px;
          "
        >
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="调整方式">
                <el-select v-model="item.effect">
                  <el-option label="INCREASE" value="INCREASE" />
                  <el-option label="DECREASE" value="DECREASE" />
                  <el-option label="TO_VALUE" value="TO_VALUE" />
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item label="优先级">
                <el-input-number v-model="item.priority" :min="1" />
              </el-form-item>
            </el-col>
          </el-row>

          <el-form-item label="条件JSON">
            <el-input type="textarea" v-model="item.condition_json" />
          </el-form-item>

          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="调整值">
                <el-input-number v-model="item.value" :min="0" :step="1000" />
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item label="调整类型">
                <el-select v-model="item.value_type">
                  <el-option label="RATE" value="RATE" />
                  <el-option label="TO_VALUE" value="TO_VALUE" />
                  <el-option label="ABS" value="ABS" />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-form-item label="上限">
            <el-input-number v-model="item.celiling_limit" :min="0" :step="1000" />
          </el-form-item>

          <el-form-item label="下限">
            <el-input-number v-model="item.floor_limit" :min="0" :step="1000" />
          </el-form-item>

          <el-form-item label="期限天数">
            <el-input-number v-model="item.term_days" :min="1" />
          </el-form-item>

          <el-form-item label="利息(%)">
            <el-input-number v-model="item.interest" :step="0.1" :min="0" />
          </el-form-item>

          <el-form-item label="服务费(%)">
            <el-input-number v-model="item.service_charge" :step="0.1" :min="0" />
          </el-form-item>

          <!-- 分期 -->
          <el-form-item label="是否可分期">
            <el-switch v-model="item.can_aging" :active-value="1" :inactive-value="0" />
          </el-form-item>

          <template v-if="item.can_aging === 1">
            <el-form-item label="分期利息(%)">
              <el-input-number v-model="item.aging_interest" :step="0.1" :min="0" />
            </el-form-item>

            <el-form-item label="分期天数">
              <el-input-number v-model="item.aging_day" :min="1" />
            </el-form-item>

            <el-form-item label="分期次数">
              <el-input v-model="item.aging_count" />
            </el-form-item>
          </template>

          <!-- 展期 -->
          <el-form-item label="是否可展期">
            <el-switch v-model="item.can_extend" :active-value="1" :inactive-value="0" />
          </el-form-item>

          <template v-if="item.can_extend === 1">
            <el-form-item label="展期利息(%)">
              <el-input-number v-model="item.extend_interest" :step="0.1" :min="0" />
            </el-form-item>

            <el-form-item label="展期天数">
              <el-input-number v-model="item.extend_day" :min="1" />
            </el-form-item>
          </template>

          <el-form-item label="场景描述">
            <el-input v-model="item.decision_scene" />
          </el-form-item>

          <el-button type="danger" size="mini" @click="removePolicy(index)"
            >删除该策略</el-button
          >
        </div>

        <el-button type="primary" icon="el-icon-plus" @click="addPolicy"
          >新增策略</el-button
        >
      </el-form>

      <span slot="footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="save">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import apiurl from "@/api/public";
import _api from "@/api/index";

export default {
  data() {
    return {
      dialogVisible: false,
      dialogTitle: "新增策略",
      policyList: [],
      mergedPolicyList: [], // 新增：合并后的策略列表
      productList: [],
      form: {
        platform: "",
        white_type: "",
        policy_adjust: [],
      },
      allPolicyData: [], // 保存后台原始数据，便于多策略编辑
    };
  },

  mounted() {
    this.getList();
    this.getproductnewAll();
  },

  methods: {
    getproductnewAll() {
      _api.get(apiurl.productnewAll1, {}).then((res) => {
        this.productList = res.data || [];
      });
    },

    getList() {
      _api
        .get(apiurl.policy, {})
        .then((res) => {
          if (res.code === 200 && res.data) {
            // 判断返回类型
            let dataList = Array.isArray(res.data) ? res.data : [res.data];

            this.allPolicyData = dataList; // 保存原始数据

            // 使用原始数据作为合并后的列表
            this.mergedPolicyList = dataList.map((item) => ({
              ...item,
              // 保持原始结构
            }));

            // 保留原有的平铺数据（如果需要的话）
            this.policyList = dataList.reduce((arr, item) => {
              if (item.policy_adjust && item.policy_adjust.length > 0) {
                const policies = item.policy_adjust.map((p) => ({
                  ...p,
                  platform: item.platform,
                  white_type: item.white_type,
                }));
                return arr.concat(policies);
              }
              return arr;
            }, []);
          } else {
            this.mergedPolicyList = [];
            this.policyList = [];
            this.$message.warning(res.data?.message || "未获取到数据");
          }
        })
        .catch((err) => {
          console.error(err);
          this.$message.error("获取策略列表失败");
        });
    },

    openAdd() {
      this.dialogTitle = "新增提额策略";
      this.form = {
        platform: "",
        white_type: "",
        policy_adjust: [this.createPolicy()],
      };
      this.dialogVisible = true;
    },

    // 多策略编辑
    openEditByPlatform(platform, white_type) {
      this.dialogTitle = "编辑提额策略";
      // 从 allPolicyData 找到对应平台和白名单的数据
      const platformData = this.allPolicyData.find(
        (item) => item.platform === platform && item.white_type === white_type
      );
      if (platformData) {
        this.form = {
          platform: platformData.platform,
          white_type: platformData.white_type,
          policy_adjust: platformData.policy_adjust.map((p) => ({ ...p })),
        };
      } else {
        this.$message.warning("未找到该平台策略");
        return;
      }
      this.dialogVisible = true;
    },

    createPolicy() {
      return {
        effect: "",
        priority: 1,
        condition_json: "",
        value: 0,
        value_type: "",
        celiling_limit: 0,
        floor_limit: 0,
        term_days: 0,
        interest: 0,
        service_charge: 0,
        fee_method: 2,
        can_aging: 0,
        can_extend: 0,
        aging_interest: 0,
        aging_day: 0,
        aging_count: 0,
        extend_interest: 0,
        extend_day: 0,
        decision_scene: "",
      };
    },

    addPolicy() {
      this.form.policy_adjust.push(this.createPolicy());
    },

    removePolicy(index) {
      this.form.policy_adjust.splice(index, 1);
    },

    save() {
      const params = {
        platform: this.form.platform,
        white_type: this.form.white_type,
        policy_adjust: this.form.policy_adjust.map((p) => {
          const copy = { ...p };
          delete copy.platform;
          delete copy.white_type;
          return copy;
        }),
      };

      _api
        .post(apiurl.policy, params)
        .then((res) => {
          if (res.code === 200) {
            this.$message.success("保存成功");
            this.dialogVisible = false;
            this.getList();
          } else {
            this.$message.error(res.message || "保存失败");
          }
        })
        .catch((err) => {
          console.error(err);
          this.$message.error("保存失败");
        });
    },

    remove(row) {
      this.$confirm("确认删除该策略吗？", "提示", { type: "warning" }).then(() => {
        _api
          .delete(apiurl.policy, {
            platform: row.platform,
            white_type: row.white_type,
          })
          .then(() => {
            this.$message.success("删除成功");
            this.getList();
          })
          .catch((err) => {
            console.error(err);
            this.$message.error("删除失败");
          });
      });
    },
  },
};
</script>
